import React, { useMemo } from "react"
import { QueryClient, QueryClientProvider } from "react-query"
import { BlockContentComponentsProvider, SanityClientConfigContext, Theme } from "@silversea-ssc/ui-components-react"
import { SkeletonTheme } from "react-loading-skeleton"
import { useRouter } from "next/router"
import { Locale } from "../format/localization"
import DefaultLayout from "../../../components/DefaultLayout/default-layout"
import { ModalProvider } from "../../../components/ModalProvider/ModalProviderContext"
import { customBlockContentComponents } from "../../../components/BlockContent/components"
import placeholderFormatterResolver from "../../../components/PlaceholderValueFormatter/resolver"
import { WebAppConfig } from "../web-app-config"
import { ConfigContext } from "../hooks/use-config"
import { Geolocation, GeolocationContext } from "./geolocation-provider"
import { I18nCatalog, LinguiProvider } from "./lingui-provider"

type CoreProps = {
    locale: Locale
    geoLocation: Geolocation
    config: WebAppConfig
    i18nCatalog: I18nCatalog
}
export const CoreProviders: React.FC<React.PropsWithChildren<CoreProps>> = ({
    locale,
    geoLocation,
    children,
    config,
    i18nCatalog,
}) => {
    const router = useRouter()

    const sanityClientConfig = useMemo(
        () => ({
            projectId: config.sanity.projectId,
            dataset: config.sanity.dataset,
            apiVersion: "2023-11-30",
            useCdn: true,
        }),
        [],
    )
    return (
        <ConfigContext.Provider value={config}>
            <LinguiProvider locale={locale} i18nCatalog={i18nCatalog}>
                <QueryClientProvider client={new QueryClient()}>
                    <BlockContentComponentsProvider
                        components={customBlockContentComponents}
                        placeholderResolver={placeholderFormatterResolver}
                    >
                        <Theme>
                            <SkeletonTheme baseColor="#e5e5e6" highlightColor="#D1D1D1">
                                <SanityClientConfigContext.Provider value={sanityClientConfig}>
                                    <GeolocationContext.Provider value={geoLocation}>
                                        <ModalProvider router={router}>
                                            <DefaultLayout>{children}</DefaultLayout>
                                        </ModalProvider>
                                    </GeolocationContext.Provider>
                                </SanityClientConfigContext.Provider>
                            </SkeletonTheme>
                        </Theme>
                    </BlockContentComponentsProvider>
                </QueryClientProvider>
            </LinguiProvider>
        </ConfigContext.Provider>
    )
}
